import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=5ddfa88c&scoped=true&"
import script from "./Columns.vue?vue&type=script&lang=js&"
export * from "./Columns.vue?vue&type=script&lang=js&"
import style0 from "./Columns.vue?vue&type=style&index=0&id=5ddfa88c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfa88c",
  null
  
)

export default component.exports